module.exports = __webpack_public_path__ + "static/img/success_bj.87e8ca2.png";